export default __webpack_public_path__ + "static/media/logo_light.61fa1b82.svg";